function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { LngLat, LngLatBounds, Map, MapMouseEvent, Popup, supported } from 'mapbox-gl';
import { Vector } from '../../utils';
import { SeatingType } from '../../types';
import { compileStyle } from '../../utils';
import { CAMERA_FOCUS_DURATION, CAMERA_PITCH, CAMERA_RESET_DURATION, CAMERA_ZOOM_DURATION, DEFAULT_CURSOR, DISTANCE_DIFF_THRESHOLD, FOCUS_ROW_ZOOM_OFFSET, MAP_CONTAINER_CLASS, MAX_BOUNDS_PADDING, NUMERIC_DIFF_THRESHOLD, ROW_ZOOM_OFFSET, SEATING_ID_PATTERN, SOURCE_ID, SOURCE_LAYER, ZOOM_IN_THRESHOLD, CAMERA_CONTROL_ZOOM_IN_ICON, CAMERA_CONTROL_ZOOM_OUT_ICON, CAMERA_CONTROL_RESET_ICON } from '../../constants';
import { VenueMapEvent } from '../VenueMapEvent/class';
export var VenueMapController = /*#__PURE__*/function () {
  function VenueMapController(_options) {
    var _this = this;
    _classCallCheck(this, VenueMapController);
    _defineProperty(this, "_parent", null);
    _defineProperty(this, "_canvas", null);
    _defineProperty(this, "_map", null);
    _defineProperty(this, "_stageLayers", []);
    _defineProperty(this, "_isVectorSource", false);
    // Position data
    _defineProperty(this, "_minZoom", 0);
    _defineProperty(this, "_rowZoom", 22);
    _defineProperty(this, "_maxZoom", 22);
    _defineProperty(this, "_originBounds", null);
    // [Todo: Reference or remove this]
    _defineProperty(this, "_maxBounds", null);
    _defineProperty(this, "_padding", 0);
    _defineProperty(this, "_sections", []);
    // Interaction state
    _defineProperty(this, "_cursorActive", false);
    _defineProperty(this, "_activePointers", new Set());
    _defineProperty(this, "_hovered", null);
    _defineProperty(this, "_highlight", null);
    _defineProperty(this, "_parentSize", {
      height: 0,
      left: 0,
      top: 0,
      width: 0
    });
    _defineProperty(this, "_lastSelectedFeatureView", null);
    _defineProperty(this, "generateCameraOptions", function (props) {
      var _seating$section, _seating$section2, _sectionMeta$rows, _seating$row, _sectionMeta$center, _rowMeta$center;
      var seatingId = props.seatingId,
        options = props.options;
      var seating = VenueMapController.parseSeatingId(seatingId !== null && seatingId !== void 0 ? seatingId : '');
      if (!_this.sectionHasRows((_seating$section = seating === null || seating === void 0 ? void 0 : seating.section) !== null && _seating$section !== void 0 ? _seating$section : '')) seating.row = '';
      var sectionMeta = _this._mapMetadata.sections[(_seating$section2 = seating.section) !== null && _seating$section2 !== void 0 ? _seating$section2 : ''];
      if (!sectionMeta) console.info('Section metadata missing.');
      var rowMeta = sectionMeta === null || sectionMeta === void 0 || (_sectionMeta$rows = sectionMeta.rows) === null || _sectionMeta$rows === void 0 ? void 0 : _sectionMeta$rows[(_seating$row = seating === null || seating === void 0 ? void 0 : seating.row) !== null && _seating$row !== void 0 ? _seating$row : ''];
      var sectionCenter = new LngLat(sectionMeta === null || sectionMeta === void 0 || (_sectionMeta$center = sectionMeta.center) === null || _sectionMeta$center === void 0 ? void 0 : _sectionMeta$center[0], sectionMeta === null || sectionMeta === void 0 ? void 0 : sectionMeta.center[1]);
      var rowCenter = rowMeta ? new LngLat(rowMeta === null || rowMeta === void 0 || (_rowMeta$center = rowMeta.center) === null || _rowMeta$center === void 0 ? void 0 : _rowMeta$center[0], rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.center[1]) : null;

      // zoom behavior
      var cameraOptions = {
        center: rowCenter || sectionCenter,
        /***
         * Former `this._rowZoom + FOCUS_ROW_ZOOM_OFFSET * (seating.row ? 1 : -1)` calculation was accommodating
         * different zoom levels depending on if a row existed or not - this behavior would differ in two ways:
         * 1. if there are rows, the zoom adjusts zoom level to show the rows
         * 2. if there are no rows, the zoom adjusts zoom level to display just the section
         *
         * The zoom level is now consistent across the board and will show rows if rows exist,
         * as well as just showing the section, if no rows exist - but all within the same zoom level
        ***/
        zoom: options.zoom || _this._rowZoom + FOCUS_ROW_ZOOM_OFFSET * 1,
        duration: CAMERA_FOCUS_DURATION,
        pitch: options.faceStage ? CAMERA_PITCH : 0,
        bearing: options.faceStage ? _this.getBearingToStage(sectionCenter) : 0
      };
      return cameraOptions;
    });
    /** Recalculate minZoom when window resizes */
    // @ts-ignore Missing ResizeObserver type in TS https://github.com/microsoft/TypeScript/issues/37861
    _defineProperty(this, "parentResize", new ResizeObserver(function (entries) {
      // eslint-disable-next-line no-restricted-syntax
      var _entries = _slicedToArray(entries, 1),
        entry = _entries[0];
      var _entry$contentRect = entry.contentRect,
        width = _entry$contentRect.width,
        height = _entry$contentRect.height,
        left = _entry$contentRect.left,
        top = _entry$contentRect.top;
      var increase = width > _this._parentSize.width;
      _this._parentSize = {
        width: width,
        height: height,
        left: left,
        top: top
      };
      _this.resizeMap(increase);
      _this.dispatchEvent({
        type: 'resize'
      });
    }));
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    if (_options.parent instanceof HTMLElement) {
      this._parent = _options.parent;
    } else {
      this._parent = document.querySelector(_options.parent);
      if (!this._parent) {
        throw new Error("No parent found for selector: ".concat(_options.parent));
      }
    }
    if (!VenueMapController.isBrowserSupported()) {
      this._parent.innerHTML = _options.fallback || '';
      this.dispatchEvent({
        type: 'error',
        error: new Error('WebGL is not supported by this browser.')
      });
      console.error('WebGL is not supported by this browser');
      return;
    }
    this._padding = _options.padding || this._padding;
    this._styleOptions = _options.styleOptions;
    // Init map element
    this.initMap(_options).then(function () {
      if (_options.sections) {
        _this.setSections(_options.sections);
      }
      _this.dispatchEvent({
        type: 'load'
      });
    })["catch"](function (e) {
      console.error('Failed to initialize map.', e);
      _this.dispatchEvent({
        type: 'error',
        code: 0,
        message: 'Failed to initialize map.',
        error: e
      });
    });
  }

  /**
   * Checks if the current browser is supported.
   * Refer to the browser support tables for [WebGL](https://caniuse.com/#feat=webgl).
   */
  _createClass(VenueMapController, [{
    key: "metadata",
    get: function get() {
      return this._mapMetadata;
    }

    /** The maps midpoint. */
  }, {
    key: "center",
    get: function get() {
      var _this$_mapMetadata;
      return (_this$_mapMetadata = this._mapMetadata) === null || _this$_mapMetadata === void 0 ? void 0 : _this$_mapMetadata.center;
    }

    /** The maps current position */
  }, {
    key: "position",
    get: function get() {
      if (!this._map) return new LngLat(0, 0);
      return this._map.getCenter();
    }

    /** The maps current zoom level (range [0, 22]). */
  }, {
    key: "zoom",
    get: function get() {
      if (!this._map) return 0;
      return this._map.getZoom();
    }

    /** The maps minimum zoom level (range [0, 22]). */
  }, {
    key: "minZoom",
    get: function get() {
      return this._minZoom;
    }

    /** The maps zoom level at which rows are visible (range [0, 22]). */
  }, {
    key: "rowZoom",
    get: function get() {
      return this._rowZoom;
    }

    /** The maps maximum zoom level (range [0, 22]). */
  }, {
    key: "maxZoom",
    get: function get() {
      return this._maxZoom;
    }

    /** The current camera compass bearing angle in degrees. */
  }, {
    key: "bearing",
    get: function get() {
      if (!this._map) return 0;
      return this._map.getBearing();
    }

    /** The current camera pitch angle in degrees. */
  }, {
    key: "pitch",
    get: function get() {
      if (!this._map) return 0;
      return this._map.getPitch();
    }

    /** The [seatingId](#seating-ids) of the section/row currently being hovered over. */
  }, {
    key: "hovered",
    get: function get() {
      return this._hovered;
    }

    /** The [seatingId](#seating-ids) of the section/row currently highlighted. */
  }, {
    key: "highlight",
    get: function get() {
      return this._highlight;
    }

    /** A list of available sections. */
  }, {
    key: "sections",
    get: function get() {
      return this._sections;
    }

    /** Whether the map has rows or not. */
  }, {
    key: "hasRows",
    get: function get() {
      return this._mapMetadata.hasRows;
    }

    /** Whether the virtual cursor is active */
  }, {
    key: "isCursorActive",
    get: function get() {
      return this._cursorActive;
    }
  }, {
    key: "isZoomRowLevel",
    value: /** Checks if the map is zoomed in enough to see rows. */
    function isZoomRowLevel() {
      if (!this._map) return false;
      return this.hasRows && this._map.getZoom() >= this._rowZoom;
    }

    /**
     * Zoom the map in by `step` amount.
     * @param step Amount to zoom in by.
     * @param animate Whether to animate the transition.
     */
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var animate = arguments.length > 1 ? arguments[1] : undefined;
      return this.zoomTo(this.zoom + step, animate);
    }

    /**
     * Zoom the map out by `step` amount.
     * @param step Amount to zoom out by.
     * @param animate Whether to animate the transition.
     */
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var animate = arguments.length > 1 ? arguments[1] : undefined;
      return this.zoomTo(this.zoom - step, animate);
    }

    /** Zoom the map to a specified `level`.
     * @param level Zoom level to transition to. The map will not zoom beyond the `minZoom`/`maxZoom`.
     * @param animate Whether to animate the transition.
     */
  }, {
    key: "zoomTo",
    value: function zoomTo(level, animate) {
      var _this2 = this;
      var targetZoom = Math.min(Math.max(this.minZoom, level), this.maxZoom);
      if (Math.abs(targetZoom - this.zoom) < NUMERIC_DIFF_THRESHOLD) {
        return Promise.resolve(this);
      }
      return new Promise(function (resolve) {
        var animationId = "zoomTo_".concat(Date.now());
        var onZoomToEnd = function onZoomToEnd(event) {
          if ((event === null || event === void 0 ? void 0 : event.id) === animationId) {
            if (!_this2._map) return;
            _this2._map.off('zoomend', onZoomToEnd);
            _this2.repaint().then(function () {
              return resolve(_this2);
            });
          }
        };
        if (!_this2._map) return;
        _this2._map.on('zoomend', onZoomToEnd);
        _this2._map.zoomTo(targetZoom, {
          duration: CAMERA_ZOOM_DURATION,
          animate: animate
        }, {
          id: animationId
        });
      });
    }

    /**
     * Transitions camera back to original zoom, center, pitch, and bearing.
     * @param animate Whether to animate the transition
     */
  }, {
    key: "resetCamera",
    value: function resetCamera(animate) {
      var _this3 = this;
      if (this.atOrigin()) return Promise.resolve(this);
      return new Promise(function (resolve) {
        var animationId = "resetCamera_".concat(Date.now());
        var onResetCameraEnd = function onResetCameraEnd(event) {
          if ((event === null || event === void 0 ? void 0 : event.id) === animationId) {
            if (!_this3._map) return;
            _this3._map.off('zoomend', onResetCameraEnd);
            _this3.repaint().then(function () {
              _this3.dispatchEvent({
                type: 'camera-reset'
              });
              resolve(_this3);
            });
          }
        };
        if (!_this3._map) return;
        _this3._map.on('zoomend', onResetCameraEnd);
        _this3._map.easeTo({
          center: _this3.center,
          zoom: _this3._minZoom,
          pitch: 0,
          bearing: 0,
          duration: animate ? CAMERA_RESET_DURATION : 0
        }, {
          id: animationId
        });
        _this3._map.triggerRepaint();
      });
    }

    /**
     * Get the current state of a section or row.
     * @param seatingId The seating object to query.
     */
  }, {
    key: "getSeatingState",
    value: function getSeatingState(seatingId) {
      var seating = VenueMapController.parseSeatingId(seatingId);
      if (!seating.section && !seating.row) {
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Invalid seatingId: \"".concat(seatingId, "\""))
        });
        return null;
      }
      if (seating.section) {
        var sectionMeta = this._mapMetadata.sections[seating.section];
        if (!sectionMeta) return null;
        var featureIds = [];
        if (seating.row && this.hasRows) {
          var _sectionMeta$rows2;
          var rowMeta = sectionMeta === null || sectionMeta === void 0 || (_sectionMeta$rows2 = sectionMeta.rows) === null || _sectionMeta$rows2 === void 0 ? void 0 : _sectionMeta$rows2[seating.row];
          if (!rowMeta) return null;
          featureIds = rowMeta.featureIds;
        } else {
          featureIds = sectionMeta.featureIds;
        }
        if (!featureIds.length) return null;
        if (!this._map) return null;
        var seatingState = this._map.getFeatureState({
          source: SOURCE_ID,
          sourceLayer: this._isVectorSource ? SOURCE_LAYER : undefined,
          id: featureIds[0]
        });
        return {
          available: seatingState.available || false,
          hovered: seatingState.hovered || false,
          highlighted: seatingState.highlighted || false,
          selected: seatingState.selected || false
        };
      }
      return null;
    }

    /**
     * Set which sections to render as available.
     * @param sections A list of available Sections.
     */
  }, {
    key: "setSections",
    value: function setSections(sections) {
      var _this4 = this;
      if (!Array.isArray(sections)) {
        this.dispatchEvent({
          type: 'error',
          error: new TypeError("Sections should be an array, instead received: ".concat(JSON.stringify(sections, null, 2), ", of type ").concat(_typeof(sections)))
        });
        return this;
      }
      // Disable previous sections/rows
      var isUnavailable = {
        available: false
      };
      this._sections.forEach(function (s) {
        _this4.setSeatingState(s.mbi, isUnavailable);
        s.rows.forEach(function (r) {
          _this4.setSeatingState("".concat(s.mbi, ":").concat(r).toLowerCase().replace(' ', '-'), isUnavailable);
        });
      });

      // Enable new sections/rows
      var isAvailable = {
        available: true
      };
      var parsedSections = sections.map(function (s) {
        _this4.setSeatingState(s.mbi, isAvailable);
        var rows = s.rows.map(function (r) {
          var row = String(r).toLowerCase();
          _this4.setSeatingState("".concat(s.mbi, ":").concat(row).toLowerCase().replace(' ', '-'), isAvailable);
          return row;
        });
        return _objectSpread(_objectSpread({}, s), {}, {
          rows: rows
        });
      });
      if (this._mapMetadata && this._mapMetadata.tileSource) {
        var _style$sources, _this$_map;
        // recompute styles
        var style = compileStyle(this._mapMetadata.tileSource, this._mapMetadata.glyphSource, sections, this._mapMetadata, {
          stageLayers: this._stageLayers,
          rowZoom: this._rowZoom
        }, this._styleOptions);
        this._isVectorSource = (style === null || style === void 0 || (_style$sources = style.sources) === null || _style$sources === void 0 ? void 0 : _style$sources[SOURCE_ID].type) === 'vector';
        (_this$_map = this._map) === null || _this$_map === void 0 || _this$_map.setStyle(style);
      }
      this._sections = parsedSections;
      return this;
    }

    /**
     * Highlight a specified section or row.
     * @param seatingId The seating object to set the state of.
     */
  }, {
    key: "setHighlight",
    value: function setHighlight(seatingId) {
      if (seatingId === this._highlight) return this;
      // Disable previous highlight
      if (this._highlight) {
        this.setSeatingState(this._highlight, {
          highlighted: false
        });
      }
      // Enable new highlight
      if (seatingId) {
        this.setSeatingState(seatingId, {
          highlighted: true
        });
      }
      this._highlight = seatingId;
      return this;
    }

    /**
     * Set the `SeatingState.selected` property of a specified section/row.
     * @param seatingId The seating object to set the state of.
     * @param selected Whether the section/row should be selected.
     */
  }, {
    key: "setSelection",
    value: function setSelection(seatingId, selected) {
      this.setSeatingState(seatingId, {
        selected: selected
      });
      return this;
    }
  }, {
    key: "syncSelectedSections",
    value: function syncSelectedSections(selectedSectionsMbis) {
      var _this5 = this;
      if (!selectedSectionsMbis.length) return this;
      selectedSectionsMbis.map(function (mbi) {
        return _this5.setSeatingState(mbi, {
          selected: true
        });
      });
      return this;
    }
  }, {
    key: "syncSelectedRows",
    value: function syncSelectedRows(selectedRows) {
      var _this6 = this;
      if (!selectedRows) return this;
      selectedRows.map(function (row) {
        _this6.setSeatingState(row, {
          selected: true
        });
      });
      return this;
    }

    /**
     * Add a popup overlay to the map.
     * @param position Coordinate to place the Popup at. (example: `[0, 0]` or `{lng: 0, lat: 0}`)
     * @param content Text/HTML content to be rendered within the popup. Make sure you escape any user inputs to prevent [XSS](<https://www.owasp.org/index.php/Cross-site_Scripting_(XSS)>) attacks.
     * @param options Optio ns to be passed to the [Popup](https://docs.com/mapbox-gl-js/api/#popup) except for `closeButton` and `closeOnClick`.
     * @returns An instance of [Popup](https://docs.com/mapbox-gl-js/api/#popup).
     */
  }, {
    key: "addPopup",
    value: function addPopup(position, content) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var filteredOptions = _objectSpread({}, options);
      delete filteredOptions.closeButton;
      delete filteredOptions.closeOnClick;
      if (!this._map) throw new Error('No map present');
      return new Popup(_objectSpread({
        closeButton: false,
        closeOnClick: false
      }, filteredOptions)).setLngLat(position).setHTML(content).addTo(this._map);
    }
  }, {
    key: "setFocus",
    value:
    /**
     * Center and zoom the map to focus on a specified section/row.
     * If a `row` is provided and the map doesn't have rows, it will focus the `section` instead
     * @param seatingId Id of the section/row to focus on.
     * @param options.zoom Desired zoom level to transition to.
     * @param options.animate Whether to animate the transition.
     * @param options.faceStage Whether to pitch and rotate map to face stage.
     * @param easeToOptions Allows you to override the camera options used
     */
    function setFocus(seatingId) {
      var _this7 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var easeToOptions = arguments.length > 2 ? arguments[2] : undefined;
      return new Promise(function (resolve, reject) {
        var cameraOptions = easeToOptions || !seatingId ? easeToOptions : _this7.generateCameraOptions({
          seatingId: seatingId,
          options: options
        });

        // Setup focus completion handler
        var animationId = "setFocus_".concat(Date.now());
        if (!cameraOptions) {
          if (options !== null && options !== void 0 && options.reset) {
            _this7._lastSelectedFeatureView = null;
          }
          return;
        }
        var onFocusEnd = function onFocusEnd(event) {
          if ((event === null || event === void 0 ? void 0 : event.id) === animationId) {
            if (!_this7._map) return;
            _this7._map.off('zoomend', onFocusEnd);
            _this7.repaint().then(function () {
              return resolve(_this7);
            });
          }
        };
        if (options !== null && options !== void 0 && options.persistFocusOptions) {
          _this7.setLastSelectedFeatureView({
            seatingId: seatingId !== null && seatingId !== void 0 ? seatingId : '',
            options: options,
            easeToOptions: cameraOptions
          });
        }
        if (!_this7._map) return;
        _this7._map.on('zoomend', onFocusEnd);
        // Trigger transition
        var eventData = {
          id: animationId
        };
        if (options.animate) {
          _this7._map.easeTo(cameraOptions, eventData);
        } else {
          _this7._map.jumpTo(cameraOptions, eventData);
        }
      });
    }

    /** Persists the most current ease to option for future reverts.
     * @param options The current EaseToOptions to persist
     */
  }, {
    key: "setLastSelectedFeatureView",
    value: function setLastSelectedFeatureView(options) {
      this._lastSelectedFeatureView = options !== null && options !== void 0 ? options : this.getCurrentMapFeatureView();
    }
  }, {
    key: "getCurrentMapFeatureView",
    value: function getCurrentMapFeatureView() {
      var _this$_map2, _this$_map3, _this$_map4, _this$_map5;
      return {
        easeToOptions: {
          animate: true,
          center: this === null || this === void 0 || (_this$_map2 = this._map) === null || _this$_map2 === void 0 ? void 0 : _this$_map2.getCenter(),
          zoom: this === null || this === void 0 || (_this$_map3 = this._map) === null || _this$_map3 === void 0 ? void 0 : _this$_map3.getZoom(),
          pitch: this === null || this === void 0 || (_this$_map4 = this._map) === null || _this$_map4 === void 0 ? void 0 : _this$_map4.getPitch(),
          bearing: this === null || this === void 0 || (_this$_map5 = this._map) === null || _this$_map5 === void 0 ? void 0 : _this$_map5.getBearing()
        },
        options: {
          animate: true,
          faceStage: false,
          persistFocusOptions: true
        }
      };
    }

    /** Reverts camera view to the most recent persisted options.
     * @param options The current EaseToOptions to persist
     */
  }, {
    key: "revertToLastSelectedFeatureView",
    value: (function () {
      var _revertToLastSelectedFeatureView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$_lastSelectedFe, _this$_lastSelectedFe2, _this$_lastSelectedFe3;
        var seatingId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              seatingId = (_this$_lastSelectedFe = this._lastSelectedFeatureView) === null || _this$_lastSelectedFe === void 0 ? void 0 : _this$_lastSelectedFe.seatingId;
              if (this._lastSelectedFeatureView) {
                _context.next = 4;
                break;
              }
              this.resetCamera(true);
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return this.setFocus(seatingId !== null && seatingId !== void 0 ? seatingId : null, _objectSpread(_objectSpread({}, (_this$_lastSelectedFe2 = this._lastSelectedFeatureView) === null || _this$_lastSelectedFe2 === void 0 ? void 0 : _this$_lastSelectedFe2.options), {}, {
                persistFocusOptions: false
              }), (_this$_lastSelectedFe3 = this._lastSelectedFeatureView) === null || _this$_lastSelectedFe3 === void 0 ? void 0 : _this$_lastSelectedFe3.easeToOptions);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function revertToLastSelectedFeatureView() {
        return _revertToLastSelectedFeatureView.apply(this, arguments);
      }
      return revertToLastSelectedFeatureView;
    }()
    /**
     * Query the viewport for visible seating features.
     * Sections are only visible at zoom levels below `rowZoom` and rows are only visible at zoom levels above `rowZoom`.
     * @param type The type of seating object to query. `section` to query sections, `row` to query rows.
     * @param matchingState The SeatingState to filter by.
     */
    )
  }, {
    key: "getVisibleSeating",
    value: function getVisibleSeating(type, matchingState) {
      var isRowLevel = this.isZoomRowLevel();
      if (type === SeatingType.Section && isRowLevel || type === SeatingType.Row && !isRowLevel) return [];
      var visibleSeating = {};
      if (!this._map) return [];
      this._map.queryRenderedFeatures({
        // @ts-ignore Missing type as first parameter can be a point or options
        layers: [type]
      }).forEach(function (feature) {
        if (!matchingState || Object.keys(matchingState).every(function (k) {
          return feature.state[k] === matchingState[k];
        })) {
          var _feature$properties;
          visibleSeating[feature === null || feature === void 0 || (_feature$properties = feature.properties) === null || _feature$properties === void 0 ? void 0 : _feature$properties.id] = true;
        }
      });
      return Object.keys(visibleSeating);
    }

    /**
     * Parse sectionId and row from a seatingId
     * @param seatingId Seating id to parse.
     */
  }, {
    key: "getSeatingCenter",
    value:
    /**
     * Retrieves the center of a given seating id
     * @param seatingId A [Row|Section] seating id
     * @returns position Coordinate to place the Popup at. (example: `[0, 0]` or `{lng: 0, lat: 0}`)
     */
    function getSeatingCenter(seatingId) {
      var _geometry, _geometry2, _geometry3;
      var _VenueMapController$p = VenueMapController.parseSeatingId(seatingId),
        section = _VenueMapController$p.section,
        row = _VenueMapController$p.row;
      if (!section && !row) {
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Invalid seatingId: \"".concat(seatingId, "\""))
        });
        return null;
      }
      if (row && !this.hasRows) {
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Trying to get row in a rowless map: \"".concat(seatingId, "\""))
        });
        return null;
      }
      var geometry = null;
      if (section) {
        geometry = this._mapMetadata.sections[section];
      }
      var notFoundRowGeometry = row && !((_geometry = geometry) !== null && _geometry !== void 0 && (_geometry = _geometry.rows) !== null && _geometry !== void 0 && _geometry[row]);
      if (!seatingId || !geometry || notFoundRowGeometry) {
        var type = row ? 'row' : 'section';
        var error = new Error("Seating geometry was not found for given ".concat(type, ": ").concat(row || section));
        this.dispatchEvent({
          error: error,
          type: 'warning',
          stack: {
            seatingType: type
          }
        });
        return null;
      }
      var seatingCenter = row ? (_geometry2 = geometry) === null || _geometry2 === void 0 || (_geometry2 = _geometry2.rows) === null || _geometry2 === void 0 || (_geometry2 = _geometry2[row]) === null || _geometry2 === void 0 ? void 0 : _geometry2.center : (_geometry3 = geometry) === null || _geometry3 === void 0 ? void 0 : _geometry3.center;
      return seatingCenter;
    }

    /**
     * Resets elements with selected state back to off
     */
  }, {
    key: "resetSelected",
    value: function resetSelected() {
      var _this8 = this;
      this._sections.forEach(function (_ref) {
        var id = _ref.mbi,
          rows = _ref.rows;
        if (!id.trim().length) return;
        _this8.setSeatingState(id, {
          selected: false
        });
        rows === null || rows === void 0 || rows.forEach(function (r) {
          _this8.setSeatingState("".concat(id, ":").concat(r), {
            selected: false
          });
        });
      });
      return this;
    }

    /**
     * Return whether the given section in the seatingId has available rows
     * @param seatingId A valid seatingId in the form of a string
     */
  }, {
    key: "sectionHasRows",
    value: function sectionHasRows(seatingId) {
      var _foundSection$rows;
      var _VenueMapController$p2 = VenueMapController.parseSeatingId(seatingId),
        section = _VenueMapController$p2.section,
        row = _VenueMapController$p2.row;
      if (!section && !row) {
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Invalid seatingId: \"".concat(seatingId, "\""))
        });
        return false;
      }
      var foundSection = this._sections.find(function (s) {
        return s.sectionId === section;
      });
      return !!(foundSection !== null && foundSection !== void 0 && (_foundSection$rows = foundSection.rows) !== null && _foundSection$rows !== void 0 && _foundSection$rows.length);
    }

    /**
     * Do the camera's zoom, position, bearing, and pitch match their starting values
     */
  }, {
    key: "atOrigin",
    value: function atOrigin() {
      if (!this._map) return true;
      if (this._map.getBearing() > NUMERIC_DIFF_THRESHOLD) return false;
      if (this._map.getPitch() > NUMERIC_DIFF_THRESHOLD) return false;
      var zoomFromOrigin = Math.abs(this._minZoom - this._map.getZoom());
      if (zoomFromOrigin > NUMERIC_DIFF_THRESHOLD) return false;
      var distFromCenter = Vector.distance(Vector.fromArray(this._map.getCenter().toArray()), Vector.fromArray(this.center.toArray()));
      return distFromCenter <= DISTANCE_DIFF_THRESHOLD;
    }

    /**
     *
     * @param active Whether the cursor should be visible
     * @param cursor text/HTML content to be rendered as the cursor. Make sure you escape any user inputs to prevent [XSS](<https://www.owasp.org/index.php/Cross-site_Scripting_(XSS)>) attacks.
     */
  }, {
    key: "setCursorActive",
    value: function setCursorActive(active, cursor) {
      var _this$_parent;
      var activeCursor = cursor !== undefined ? cursor : DEFAULT_CURSOR;
      var venueMapCenterQuerySelector = (_this$_parent = this._parent) === null || _this$_parent === void 0 ? void 0 : _this$_parent.querySelector('.vs-venue-map-center');
      if (!venueMapCenterQuerySelector) return this;
      venueMapCenterQuerySelector.innerHTML = active ? activeCursor : '';
      this._cursorActive = active;
      return this;
    }

    /**
     * Add an event listener.
     * @param listener An event listener that will be called when the event triggers.
     */
  }, {
    key: "on",
    value: function on(eventType, listener) {
      var _this$_parent2;
      (_this$_parent2 = this._parent) === null || _this$_parent2 === void 0 || _this$_parent2.addEventListener(eventType, listener);
      return this;
    }

    /**
     * Add an event listener.
     * @param listener An event listener that will be called when the event triggers.
     */
  }, {
    key: "off",
    value: function off(eventType, listener) {
      var _this$_parent3;
      (_this$_parent3 = this._parent) === null || _this$_parent3 === void 0 || _this$_parent3.removeEventListener(eventType, listener);
      return this;
    }
  }, {
    key: "initElement",
    value: function initElement(options) {
      var _this$_parent4,
        _this9 = this,
        _this$_parent5,
        _this$_parent6,
        _this$_parent7,
        _this$_parent8;
      if (typeof document === 'undefined' || typeof window === 'undefined') return;
      var innerContent = "\n            <div class=\"vs-venue-map\">\n                <div class=\"".concat(MAP_CONTAINER_CLASS, "\"></div>\n                <div class=\"vs-venue-map-overlay\">\n                    <div class=\"vs-venue-map-overlay-corner top-left\"></div>\n                    <div class=\"vs-venue-map-overlay-corner top-right\">\n                        <div class=\"vs-venue-map-camera-controls\">\n                            <div class=\"vs-venue-map-camera-control vs-venue-map-zoom-control\">\n                                <button class=\"zoom-in\">\n                                    ").concat(CAMERA_CONTROL_ZOOM_IN_ICON, "\n                                </button>\n                                <button class=\"zoom-out\">\n                                    ").concat(CAMERA_CONTROL_ZOOM_OUT_ICON, "\n                                </button>\n                            </div>\n                            <button class=\"vs-venue-map-camera-control reset-camera\">\n                                ").concat(CAMERA_CONTROL_RESET_ICON, "\n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"vs-venue-map-center\">\n                        ").concat(options.activeCursor ? DEFAULT_CURSOR : '', "\n                    </div>\n                    <div class=\"vs-venue-map-overlay-corner bottom-left\">\n                        ").concat(options.enableWatermark ? "\n                            <a class=\"vs-venue-map-attribution-link\" href=\"".concat(options.watermarkHref, "\">\n                                <img src=\"").concat(options.watermarkSrc, "\" alt=\"").concat(options.watermarkAltText, "\" />\n                            </a>\n                           ") : '', "\n                     </div>\n                    <div class=\"vs-venue-map-overlay-corner bottom-right\"></div>\n                </div>\n            </div>\n        ");
      if (this._parent) this._parent.innerHTML = innerContent;
      (_this$_parent4 = this._parent) === null || _this$_parent4 === void 0 || (_this$_parent4 = _this$_parent4.querySelector('.zoom-in')) === null || _this$_parent4 === void 0 || _this$_parent4.addEventListener('click', function (e) {
        _this9.dispatchEvent({
          type: 'zoom-in-click',
          originalEvent: e
        });
        _this9.zoomIn(1, true);
      });
      (_this$_parent5 = this._parent) === null || _this$_parent5 === void 0 || (_this$_parent5 = _this$_parent5.querySelector('.zoom-out')) === null || _this$_parent5 === void 0 || _this$_parent5.addEventListener('click', function (e) {
        _this9.dispatchEvent({
          type: 'zoom-out-click',
          originalEvent: e
        });
        _this9.zoomOut(1, true);
      });
      (_this$_parent6 = this._parent) === null || _this$_parent6 === void 0 || (_this$_parent6 = _this$_parent6.querySelector('.reset-camera')) === null || _this$_parent6 === void 0 || _this$_parent6.addEventListener('click', function (e) {
        _this9.dispatchEvent({
          type: 'reset-click',
          originalEvent: e
        });
        _this9.resetCamera(true);
      });

      // Manage active pointers change
      (_this$_parent7 = this._parent) === null || _this$_parent7 === void 0 || _this$_parent7.addEventListener('pointerdown', this.onPointerDown.bind(this), {
        capture: true
      });
      (_this$_parent8 = this._parent) === null || _this$_parent8 === void 0 || _this$_parent8.addEventListener('pointerup', this.onPointerUp.bind(this), {
        capture: true
      });
    }

    /** Add new pointers to list */
  }, {
    key: "onPointerDown",
    value: function onPointerDown(event) {
      if (event.pointerType === 'touch') {
        this._activePointers.add(event.pointerId);
      }
    }

    /**
     * Deletes lifted pointer and if it
     * happens to be the first active pointer
     * stops the map from being dragged
     * https://github.com/mapbox/mapbox-gl-js/issues/9136
     */
  }, {
    key: "onPointerUp",
    value: function onPointerUp(event) {
      if (event.pointerType === 'touch') {
        var _Array$from = Array.from(this._activePointers),
          _Array$from2 = _slicedToArray(_Array$from, 1),
          firstPointer = _Array$from2[0];
        var activePointersQty = this._activePointers.size;
        if (!this._map) return;
        if (activePointersQty === 2 && firstPointer === event.pointerId) {
          event.preventDefault();
          this._map.dragPan.disable();
        } else if (activePointersQty === 1) {
          this._map.dragPan.enable();
        }
        this._activePointers["delete"](event.pointerId);
      }
    }
  }, {
    key: "resizeMap",
    value: function resizeMap() {
      var increase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this._map) return;
      this._map.resize();
      var cameraForOrigin = this._map.cameraForBounds(this._mapMetadata.bounds, {
        padding: this._padding
      });
      if (!cameraForOrigin) {
        return;
      }
      var newZoom = cameraForOrigin.zoom;
      if (increase) {
        this.setMinZoom(newZoom);
        this.setMaxZoom(newZoom + ZOOM_IN_THRESHOLD);
        this._map.setZoom(newZoom);
      } else {
        this.setMaxBounds(this._mapMetadata.bounds, this._padding);
        this.setMinZoom(newZoom);
        this._map.setZoom(newZoom);
      }
    }
  }, {
    key: "initMap",
    value: function () {
      var _initMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        var _style$sources2,
          _this$_parent$querySe,
          _this$_parent9,
          _this10 = this,
          _this$_parent10;
        var pass, style;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof document === 'undefined' || typeof window === 'undefined')) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!(typeof options.data === 'string')) {
                _context2.next = 8;
                break;
              }
              _context2.next = 5;
              return VenueMapController.downloadMetadata(options.data);
            case 5:
              this._mapMetadata = _context2.sent;
              _context2.next = 9;
              break;
            case 8:
              this._mapMetadata = options.data;
            case 9:
              if (!this._mapMetadata.stageStyle) {
                _context2.next = 15;
                break;
              }
              _context2.next = 12;
              return this.downloadStageLayers(this._mapMetadata.stageStyle);
            case 12:
              this._stageLayers = _context2.sent;
              _context2.next = 16;
              break;
            case 15:
              this._stageLayers = [];
            case 16:
              pass = (Math.random() + 1).toString(36).substring(7); // Initialize map
              this.initElement(options);
              style = compileStyle(this._mapMetadata.tileSource, this._mapMetadata.glyphSource, (options === null || options === void 0 ? void 0 : options.sections) || [], this._mapMetadata, {
                stageLayers: this._stageLayers,
                rowZoom: this._rowZoom
              }, this._styleOptions);
              this._isVectorSource = (style === null || style === void 0 || (_style$sources2 = style.sources) === null || _style$sources2 === void 0 ? void 0 : _style$sources2[SOURCE_ID].type) === 'vector';
              this._map = new Map({
                container: (_this$_parent$querySe = (_this$_parent9 = this._parent) === null || _this$_parent9 === void 0 ? void 0 : _this$_parent9.querySelector(".".concat(MAP_CONTAINER_CLASS))) !== null && _this$_parent$querySe !== void 0 ? _this$_parent$querySe : '',
                style: style,
                attributionControl: false,
                doubleClickZoom: false,
                dragRotate: false,
                keyboard: false,
                renderWorldCopies: false,
                bounds: this._mapMetadata.bounds,
                trackResize: true,
                fitBoundsOptions: {
                  padding: this._padding
                }
              }).on('error', function (event) {
                console.debug('Mapbox init encountered an error.', event);
                _this10.dispatchEvent({
                  type: 'error',
                  code: 1,
                  message: 'Mapbox error.',
                  error: event.error
                });
              });
              // Wait for map to load
              _context2.next = 23;
              return new Promise(function (resolve) {
                var _this10$_map;
                (_this10$_map = _this10._map) === null || _this10$_map === void 0 || _this10$_map.once('load', function () {
                  return resolve(null);
                });
              });
            case 23:
              // Set parameters after map load
              this._cursorActive = options.activeCursor || false;
              this._canvas = this._map.getCanvas();
              this._originBounds = this._map.getBounds();
              this.setMaxBounds(this._originBounds, MAX_BOUNDS_PADDING);
              this.setMinZoom(this.zoom);
              this.setRowZoom(this._minZoom + ROW_ZOOM_OFFSET, (options === null || options === void 0 ? void 0 : options.sections) || [], this._mapMetadata);
              this.setMaxZoom(this._mapMetadata.hasRows ? this._rowZoom + ROW_ZOOM_OFFSET : this._rowZoom - 0.1);

              // Initialize events
              this._map.on('dragend', this.onDragEnd.bind(this));
              this._map.on('zoomend', this.onZoomEnd.bind(this));
              this._map.on('moveend', this.onMoveEnd.bind(this));
              this._map.on('mousemove', 'section', this.onSectionMouseMove.bind(this));
              this._map.on('mouseleave', 'section', this.onSectionMouseLeave.bind(this));
              this._map.on('click', 'section', this.onSectionClick.bind(this));

              // Disable rotation
              this._map.dragRotate.disable();
              this._map.touchZoomRotate.disableRotation();
              // Include row events
              if (this._mapMetadata.hasRows) {
                this._map.on('mousemove', 'row', this.onRowMouseMove.bind(this));
                this._map.on('mouseleave', 'row', this.onRowMouseLeave.bind(this));
                this._map.on('click', 'row', this.onRowClick.bind(this));
              }
              // Add initialized class to element
              (_this$_parent10 = this._parent) === null || _this$_parent10 === void 0 || (_this$_parent10 = _this$_parent10.querySelector('.vs-venue-map')) === null || _this$_parent10 === void 0 || _this$_parent10.classList.add('initialized');
              if (this._parent) this.parentResize.observe(this._parent);
            case 41:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function initMap(_x) {
        return _initMap.apply(this, arguments);
      }
      return initMap;
    }()
    /**
     * Set the max bounds that the map can be zoom/panned within
     * @param bounds The maximum bounding box to set
     * @param padding Padding around bounding box as a percentage of the bounds width and height
     */
  }, {
    key: "setMaxBounds",
    value: function setMaxBounds(bounds, padding) {
      var _this$_map6;
      var maxBounds = LngLatBounds.convert(bounds);
      if (padding) {
        var lonOffset = Math.abs(maxBounds.getEast() - maxBounds.getWest()) * padding;
        var latOffset = Math.abs(maxBounds.getNorth() - maxBounds.getSouth()) * padding;
        maxBounds = new LngLatBounds(new LngLat(maxBounds.getWest() - lonOffset, maxBounds.getSouth() - latOffset), new LngLat(maxBounds.getEast() + lonOffset, maxBounds.getNorth() + latOffset));
      }
      this._maxBounds = maxBounds;
      (_this$_map6 = this._map) === null || _this$_map6 === void 0 || _this$_map6.setMaxBounds(maxBounds);
    }
  }, {
    key: "setMinZoom",
    value: function setMinZoom(zoomLevel) {
      var _this$_map7;
      this._minZoom = zoomLevel;
      (_this$_map7 = this._map) === null || _this$_map7 === void 0 || _this$_map7.setMinZoom(zoomLevel);
    }
  }, {
    key: "setRowZoom",
    value: function setRowZoom(zoomLevel, sections, mapMetadata) {
      this._rowZoom = zoomLevel;
      if (this._mapMetadata && this._mapMetadata.tileSource) {
        var _this$_map8;
        (_this$_map8 = this._map) === null || _this$_map8 === void 0 || _this$_map8.setStyle(compileStyle(this._mapMetadata.tileSource, this._mapMetadata.glyphSource, sections, mapMetadata, {
          stageLayers: this._stageLayers,
          rowZoom: zoomLevel
        }, this._styleOptions));
      }
    }
  }, {
    key: "setMaxZoom",
    value: function setMaxZoom(zoomLevel) {
      if (!this._map) return;
      this._maxZoom = zoomLevel;
      this._map.setMaxZoom(zoomLevel);
    }
  }, {
    key: "setSeatingState",
    value: function setSeatingState(seatingId, state) {
      var _this11 = this;
      var seating = VenueMapController.parseSeatingId(seatingId);
      if (!seating.section && !seating.row) {
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Invalid seatingId: \"".concat(seatingId, "\""))
        });
        return;
      }
      if (seating.section) {
        var _this$_mapMetadata2;
        var sectionMeta = (_this$_mapMetadata2 = this._mapMetadata) === null || _this$_mapMetadata2 === void 0 || (_this$_mapMetadata2 = _this$_mapMetadata2.sections) === null || _this$_mapMetadata2 === void 0 ? void 0 : _this$_mapMetadata2[seating.section];
        if (!sectionMeta) return;
        var featureIds = [];
        if (seating.row) {
          var _sectionMeta$rows3;
          var rowMeta = sectionMeta === null || sectionMeta === void 0 || (_sectionMeta$rows3 = sectionMeta.rows) === null || _sectionMeta$rows3 === void 0 ? void 0 : _sectionMeta$rows3[seating.row];
          if (!rowMeta) return;
          featureIds = rowMeta.featureIds;
        } else {
          featureIds = sectionMeta.featureIds;
        }
        // Update feature state
        featureIds.forEach(function (featureId) {
          var _this11$_map;
          (_this11$_map = _this11._map) === null || _this11$_map === void 0 || _this11$_map.setFeatureState({
            source: SOURCE_ID,
            sourceLayer: _this11._isVectorSource ? SOURCE_LAYER : undefined,
            id: featureId
          }, state);
        });
      }
    }
  }, {
    key: "setHovered",
    value: function setHovered(seatingId) {
      if (seatingId === this._hovered) return;
      // Disable previous hovered section/row
      if (this._hovered) {
        this.setSeatingState(this._hovered, {
          hovered: false
        });
      }
      // Enable new hovered section/row
      if (seatingId) {
        this.setSeatingState(seatingId, {
          hovered: true
        });
      }
      this._hovered = seatingId;
    }
  }, {
    key: "downloadStageLayers",
    value: function () {
      var _downloadStageLayers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return fetch(url);
            case 3:
              _context3.next = 5;
              return _context3.sent.json();
            case 5:
              return _context3.abrupt("return", _context3.sent);
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              this.dispatchEvent({
                error: _context3.t0,
                message: 'An error ocurred when trying to download the layers',
                type: 'error'
              });
              return _context3.abrupt("return", []);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 8]]);
      }));
      function downloadStageLayers(_x2) {
        return _downloadStageLayers.apply(this, arguments);
      }
      return downloadStageLayers;
    }()
  }, {
    key: "getBearingToStage",
    value: function getBearingToStage(coordinate) {
      var cameraPosition = new Vector(coordinate.lng, coordinate.lat);
      var center = new Vector(this.center.lng, this.center.lat);
      var up = new Vector(0, 1);
      var toStage = center.subtract(cameraPosition);
      var angle = -Vector.angleBetween(up, toStage);
      return angle * 180 / Math.PI;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      var _this$_parent11;
      return (_this$_parent11 = this._parent) === null || _this$_parent11 === void 0 ? void 0 : _this$_parent11.dispatchEvent(new CustomEvent(event.type, {
        detail: _objectSpread({
          instance: this
        }, event)
      }));
    }
  }, {
    key: "repaint",
    value: function repaint() {
      var _this12 = this;
      return new Promise(function (resolve) {
        if (!_this12._map) return;
        _this12._map.once('render', function () {
          return resolve();
        });
        _this12._map.triggerRepaint();
      });
    }
  }, {
    key: "getFeatureAtPoint",
    value: function getFeatureAtPoint(point) {
      if (!this._map) return null;
      return this._map.queryRenderedFeatures(point, {
        layers: [this.isZoomRowLevel() ? 'row' : 'section']
      })[0] || null;
    }

    /* Event Handlers */
  }, {
    key: "onDragEnd",
    value: function onDragEnd(event) {
      var _feature, _feature2, _feature3;
      var feature = null;
      this.setLastSelectedFeatureView();
      if (this._cursorActive) {
        var _this$_parentSize = this._parentSize,
          width = _this$_parentSize.width,
          height = _this$_parentSize.height;
        feature = this.getFeatureAtPoint([width / 2, height / 2]);
      }
      var _ref2 = feature && VenueMapController.parseSeatingId((_feature = feature) === null || _feature === void 0 || (_feature = _feature.properties) === null || _feature === void 0 ? void 0 : _feature.id) || {},
        section = _ref2.section,
        row = _ref2.row;
      this.dispatchEvent({
        type: 'dragend',
        originalEvent: event,
        featureState: (_feature2 = feature) === null || _feature2 === void 0 ? void 0 : _feature2.state,
        section: feature && this._sections.find(function (s) {
          return s.mbi === section;
        }),
        sectionGeometryMeta: feature && this._mapMetadata.sections[section !== null && section !== void 0 ? section : ''],
        row: feature && {
          id: (_feature3 = feature) === null || _feature3 === void 0 || (_feature3 = _feature3.properties) === null || _feature3 === void 0 ? void 0 : _feature3.id,
          name: row
        }
      });
    }
  }, {
    key: "onMoveEnd",
    value: function onMoveEnd() {
      var targetZoom = Math.min(Math.max(this.minZoom, this.zoom), this.maxZoom);
      this.setOverlayOpacity(this.maxZoom, targetZoom);
    }
  }, {
    key: "onZoomEnd",
    value: function onZoomEnd(event) {
      var _feature5, _feature6, _feature7;
      // persist only user initiated events
      if (event !== null && event !== void 0 && event.originalEvent) this.setLastSelectedFeatureView();
      var feature = null;
      var _this$_parentSize2 = this._parentSize,
        left = _this$_parentSize2.left,
        top = _this$_parentSize2.top,
        width = _this$_parentSize2.width,
        height = _this$_parentSize2.height;
      var _ref3 = event.originalEvent || {},
        clientX = _ref3.clientX,
        clientY = _ref3.clientY;
      if (this._cursorActive) {
        feature = this.getFeatureAtPoint([width / 2, height / 2]);
      } else if (clientX !== undefined && clientY !== undefined) {
        feature = this.getFeatureAtPoint([clientX - left, clientY - top]);
      }
      if (feature && feature.state.available) {
        var _feature4;
        this.setHovered(feature && ((_feature4 = feature) === null || _feature4 === void 0 || (_feature4 = _feature4.properties) === null || _feature4 === void 0 ? void 0 : _feature4.id));
      }
      var _ref4 = feature && VenueMapController.parseSeatingId((_feature5 = feature) === null || _feature5 === void 0 || (_feature5 = _feature5.properties) === null || _feature5 === void 0 ? void 0 : _feature5.id) || {},
        section = _ref4.section,
        row = _ref4.row;
      if (!section) return;
      var foundSection = this._sections.find(function (s) {
        return s.mbi === section;
      });
      this.dispatchEvent({
        type: 'zoomend',
        originalEvent: event,
        featureState: (_feature6 = feature) === null || _feature6 === void 0 ? void 0 : _feature6.state,
        section: feature && foundSection,
        sectionGeometryMeta: feature && this._mapMetadata.sections[section],
        row: feature && {
          id: (_feature7 = feature) === null || _feature7 === void 0 || (_feature7 = _feature7.properties) === null || _feature7 === void 0 ? void 0 : _feature7.id,
          name: row
        }
      });
    }
  }, {
    key: "onSectionMouseMove",
    value: function onSectionMouseMove(event) {
      var _sectionFeature$prope, _sectionFeature$prope3;
      if (this.isZoomRowLevel() || !event.features) return;
      var _event$features = _slicedToArray(event.features, 1),
        sectionFeature = _event$features[0];
      // Validate current seating
      var parsedSeatingId = VenueMapController.parseSeatingId(sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope = sectionFeature.properties) === null || _sectionFeature$prope === void 0 ? void 0 : _sectionFeature$prope.id);
      if (!parsedSeatingId.section && !parsedSeatingId.row) {
        var _sectionFeature$prope2;
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Invalid seatingId: \"".concat(sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope2 = sectionFeature.properties) === null || _sectionFeature$prope2 === void 0 ? void 0 : _sectionFeature$prope2.id, "\""))
        });
        return;
      }
      // Trigger section leave on section change
      if (this.hovered && this.hovered !== (sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope3 = sectionFeature.properties) === null || _sectionFeature$prope3 === void 0 ? void 0 : _sectionFeature$prope3.id)) {
        var _VenueMapController$p3 = VenueMapController.parseSeatingId(this.hovered),
          section = _VenueMapController$p3.section;
        this.setHovered(null);
        if (!section) return;
        this.dispatchEvent({
          type: 'section-leave',
          originalEvent: event,
          section: this._sections.find(function (s) {
            return s.sectionId === section;
          }),
          sectionGeometryMeta: this._mapMetadata.sections[section]
        });
      }
      // Section move action
      if (sectionFeature.state.available) {
        var _sectionFeature$prope4, _sectionFeature$prope6;
        if (this._canvas) this._canvas.style.cursor = 'pointer';
        this.setHovered(sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope4 = sectionFeature.properties) === null || _sectionFeature$prope4 === void 0 ? void 0 : _sectionFeature$prope4.id);
        this.dispatchEvent({
          type: 'section-hover',
          originalEvent: event,
          featureState: sectionFeature.state,
          section: this._sections.find(function (s) {
            var _sectionFeature$prope5;
            return s.mbi === (sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope5 = sectionFeature.properties) === null || _sectionFeature$prope5 === void 0 ? void 0 : _sectionFeature$prope5.id);
          }),
          sectionGeometryMeta: this._mapMetadata.sections[sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope6 = sectionFeature.properties) === null || _sectionFeature$prope6 === void 0 ? void 0 : _sectionFeature$prope6.id]
        });
      }
    }
  }, {
    key: "onSectionMouseLeave",
    value: function onSectionMouseLeave(event) {
      var _this$hovered, _parsedSeatingId$sect;
      if (this.isZoomRowLevel()) return;
      var parsedSeatingId = VenueMapController.parseSeatingId((_this$hovered = this.hovered) !== null && _this$hovered !== void 0 ? _this$hovered : '');
      if (this._canvas) this._canvas.style.cursor = '';
      this.setHovered(null);
      this.dispatchEvent({
        type: 'section-leave',
        originalEvent: event,
        section: this._sections.find(function (s) {
          return s.sectionId === parsedSeatingId.section;
        }),
        sectionGeometryMeta: this._mapMetadata.sections[(_parsedSeatingId$sect = parsedSeatingId === null || parsedSeatingId === void 0 ? void 0 : parsedSeatingId.section) !== null && _parsedSeatingId$sect !== void 0 ? _parsedSeatingId$sect : '']
      });
    }
  }, {
    key: "onSectionClick",
    value: function onSectionClick(event) {
      var _this$_map9;
      if (this.isZoomRowLevel()) return;
      var features = (_this$_map9 = this._map) === null || _this$_map9 === void 0 ? void 0 : _this$_map9.queryRenderedFeatures(event.point, {
        layers: ['section']
      });
      if (!(features !== null && features !== void 0 && features.length) || !event.features) return;
      var _event$features2 = _slicedToArray(event.features, 1),
        sectionFeature = _event$features2[0];
      if (sectionFeature.state.available) {
        var _sectionFeature$prope8;
        this.setHovered(null);
        this.dispatchEvent({
          type: 'section-click',
          originalEvent: event,
          featureState: sectionFeature.state,
          section: this._sections.find(function (s) {
            var _sectionFeature$prope7;
            return s.mbi === (sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope7 = sectionFeature.properties) === null || _sectionFeature$prope7 === void 0 ? void 0 : _sectionFeature$prope7.id);
          }),
          sectionGeometryMeta: this._mapMetadata.sections[sectionFeature === null || sectionFeature === void 0 || (_sectionFeature$prope8 = sectionFeature.properties) === null || _sectionFeature$prope8 === void 0 ? void 0 : _sectionFeature$prope8.id]
        });
      }
    }
  }, {
    key: "onRowMouseMove",
    value: function onRowMouseMove(event) {
      var _rowFeature$propertie, _rowFeature$propertie3;
      if (!this.isZoomRowLevel() || !event.features) return;
      var _event$features3 = _slicedToArray(event.features, 1),
        rowFeature = _event$features3[0];

      // Validate seating
      var parsedSeatingId = VenueMapController.parseSeatingId(rowFeature === null || rowFeature === void 0 || (_rowFeature$propertie = rowFeature.properties) === null || _rowFeature$propertie === void 0 ? void 0 : _rowFeature$propertie.id);
      if (!parsedSeatingId.section && !parsedSeatingId.row) {
        var _rowFeature$propertie2;
        this.dispatchEvent({
          type: 'warning',
          error: new Error("Invalid seatingId: \"".concat((_rowFeature$propertie2 = rowFeature.properties) === null || _rowFeature$propertie2 === void 0 ? void 0 : _rowFeature$propertie2.id, "\""))
        });
        return;
      }
      // Dispatch row-leave when changing to another row
      if (this.hovered && this.hovered !== ((_rowFeature$propertie3 = rowFeature.properties) === null || _rowFeature$propertie3 === void 0 ? void 0 : _rowFeature$propertie3.id)) {
        var _VenueMapController$p4 = VenueMapController.parseSeatingId(this.hovered),
          section = _VenueMapController$p4.section,
          row = _VenueMapController$p4.row;
        this.setHovered(null);
        if (!section) return;
        this.dispatchEvent({
          type: 'row-leave',
          originalEvent: event,
          section: this._sections.find(function (s) {
            return s.sectionId === section;
          }),
          sectionGeometryMeta: this._mapMetadata.sections[section],
          row: {
            id: this.hovered,
            name: row
          }
        });
      }
      // Trigger row-move for current one if it's available
      if (rowFeature.state.available) {
        var _rowFeature$propertie4, _parsedSeatingId$sect2, _rowFeature$propertie5;
        if (this._canvas) this._canvas.style.cursor = 'pointer';
        this.setHovered((_rowFeature$propertie4 = rowFeature.properties) === null || _rowFeature$propertie4 === void 0 ? void 0 : _rowFeature$propertie4.id);
        this.dispatchEvent({
          type: 'row-hover',
          originalEvent: event,
          featureState: rowFeature.state,
          section: this._sections.find(function (s) {
            return s.sectionId === parsedSeatingId.section;
          }),
          sectionGeometryMeta: this._mapMetadata.sections[(_parsedSeatingId$sect2 = parsedSeatingId.section) !== null && _parsedSeatingId$sect2 !== void 0 ? _parsedSeatingId$sect2 : ''],
          row: {
            id: (_rowFeature$propertie5 = rowFeature.properties) === null || _rowFeature$propertie5 === void 0 ? void 0 : _rowFeature$propertie5.id,
            name: parsedSeatingId.row
          }
        });
      }
    }
  }, {
    key: "onRowMouseLeave",
    value: function onRowMouseLeave(event) {
      var _this$hovered2, _parsedSeatingId$sect3, _this$hovered3;
      if (!this.isZoomRowLevel()) return;
      var parsedSeatingId = VenueMapController.parseSeatingId((_this$hovered2 = this.hovered) !== null && _this$hovered2 !== void 0 ? _this$hovered2 : '');
      if (this._canvas) this._canvas.style.cursor = '';
      this.dispatchEvent({
        type: 'row-leave',
        originalEvent: event,
        section: this._sections.find(function (s) {
          return s.sectionId === parsedSeatingId.section;
        }),
        sectionGeometryMeta: this._mapMetadata.sections[(_parsedSeatingId$sect3 = parsedSeatingId.section) !== null && _parsedSeatingId$sect3 !== void 0 ? _parsedSeatingId$sect3 : ''],
        row: {
          id: this.hovered,
          name: VenueMapController.parseSeatingId((_this$hovered3 = this.hovered) !== null && _this$hovered3 !== void 0 ? _this$hovered3 : '').row
        }
      });
      this.setHovered(null);
    }
  }, {
    key: "onRowClick",
    value: function onRowClick(event) {
      var _this$_map10;
      if (!this.isZoomRowLevel()) return;
      var features = (_this$_map10 = this._map) === null || _this$_map10 === void 0 ? void 0 : _this$_map10.queryRenderedFeatures(event.point, {
        layers: ['row']
      });
      if (!(features !== null && features !== void 0 && features.length) || !event.features) return;
      var _event$features4 = _slicedToArray(event.features, 1),
        rowFeature = _event$features4[0];
      if (rowFeature.state.available) {
        var _rowFeature$propertie6, _rowFeature$propertie7, _rowFeature$propertie8;
        var parsedSeatingId = VenueMapController.parseSeatingId((_rowFeature$propertie6 = rowFeature.properties) === null || _rowFeature$propertie6 === void 0 ? void 0 : _rowFeature$propertie6.id);
        if (!parsedSeatingId.section && !parsedSeatingId.row) {
          this.dispatchEvent({
            type: 'warning',
            error: new Error("Invalid seatingId: \"".concat(parsedSeatingId, "\""))
          });
          return;
        }
        this.dispatchEvent({
          type: 'row-click',
          originalEvent: event,
          featureState: rowFeature.state,
          section: this._sections.find(function (s) {
            return s.sectionId === parsedSeatingId.section;
          }),
          sectionGeometryMeta: this._mapMetadata.sections[(_rowFeature$propertie7 = rowFeature.properties) === null || _rowFeature$propertie7 === void 0 ? void 0 : _rowFeature$propertie7.id],
          row: {
            id: (_rowFeature$propertie8 = rowFeature.properties) === null || _rowFeature$propertie8 === void 0 ? void 0 : _rowFeature$propertie8.id,
            name: parsedSeatingId.row
          },
          setFocus: false
        });
      }
    }
  }, {
    key: "setOverlayOpacity",
    value: function setOverlayOpacity(maxZoom, targetZoom) {
      var _this$_parent12;
      var delta = 0.25;
      var opacity = (maxZoom - targetZoom) * delta;
      var overlayImage = (_this$_parent12 = this._parent) === null || _this$_parent12 === void 0 ? void 0 : _this$_parent12.querySelector('.bottom-left');
      var imageLink = overlayImage === null || overlayImage === void 0 ? void 0 : overlayImage.querySelector('a');
      if (overlayImage instanceof HTMLElement) {
        overlayImage.style.opacity = String(opacity);
        if (imageLink) imageLink.style.pointerEvents = this.isZoomRowLevel() ? 'none' : 'all';
      }
    }
  }], [{
    key: "isBrowserSupported",
    value: function isBrowserSupported() {
      return supported();
    }
  }, {
    key: "parseSeatingId",
    value: function parseSeatingId(seatingId) {
      if (!SEATING_ID_PATTERN.exec(seatingId)) {
        // TODO a invalid seating should throw out of the action
        return {
          section: null,
          row: null
        };
      }
      var splitId = seatingId ? seatingId.split(':') : [];
      return {
        section: splitId.length ? splitId[0] : null,
        row: splitId.length > 1 ? splitId[1] : null
      };
    }
  }, {
    key: "downloadMetadata",
    value: function () {
      var _downloadMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(source) {
        var response, bounds, center;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetch(source);
            case 2:
              _context4.next = 4;
              return _context4.sent.json();
            case 4:
              response = _context4.sent;
              bounds = new LngLatBounds(response.bounds);
              center = bounds.getCenter();
              return _context4.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                bounds: bounds,
                center: center
              }));
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function downloadMetadata(_x3) {
        return _downloadMetadata.apply(this, arguments);
      }
      return downloadMetadata;
    }()
  }, {
    key: "debounce",
    value: function debounce(func) {
      var _this13 = this;
      var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        // eslint-disable-next-line
        var context = _this13;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          return func.apply(context, args);
        }, wait);
      };
    }
  }]);
  return VenueMapController;
}();

/**
 * | Type            | Description                                                       |
 * | --------------- | ----------------------------------------------------------------- |
 * | `camera-reset`  | Fired when the camera is reset.                                   |
 * | `dragend`       | Fired when the map finishes being dragged/panned.                 |
 * | `load`          | Fired when the map finishes loading.                              |
 * | `reset-click`   | Fired when the user clicks the reset button                       |
 * | `row-click`     | Fired when the user clicks an available row.                      |
 * | `row-hover`     | Fired when the user moves their cursor over an available row      |
 * | `row-leave`     | Fired when the user's cursor moves off of an available row.       |
 * | `section-click` | Fired when the user clicks an available section.                  |
 * | `section-hover` | Fired when the user moves their cursor over an available section. |
 * | `section-leave` | Fired when the user's cursor moves off of an available section.   |
 * | `zoom-in-click` | Fired when the user clicks  the zoom-in button.                   |
 * | `zoom-out-click`| Fired when the user clicks  the zoom-out button.                  |
 * | `zoomend`       | Fired when the map finishes zooming in/out.                       |
 * | --------------- | ----------------------------------------------------------------- |
 * | `error`         | Fired when the map encounters an error.                           |
 * | `warning`       | Fired when the the map generates a non-critical error.            |
 */

export var VenueMapInputEvent = /*#__PURE__*/function (_VenueMapEvent) {
  _inherits(VenueMapInputEvent, _VenueMapEvent);
  function VenueMapInputEvent() {
    var _this14;
    _classCallCheck(this, VenueMapInputEvent);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this14 = _callSuper(this, VenueMapInputEvent, [].concat(args));
    _defineProperty(_assertThisInitialized(_this14), "originalEvent", new MapMouseEvent());
    return _this14;
  }
  return _createClass(VenueMapInputEvent);
}(VenueMapEvent);
export var VenueMapSectionInputEvent = /*#__PURE__*/function (_VenueMapInputEvent2) {
  _inherits(VenueMapSectionInputEvent, _VenueMapInputEvent2);
  function VenueMapSectionInputEvent() {
    _classCallCheck(this, VenueMapSectionInputEvent);
    return _callSuper(this, VenueMapSectionInputEvent, arguments);
  }
  return _createClass(VenueMapSectionInputEvent);
}(VenueMapInputEvent);
export var VenueMapRowInputEvent = /*#__PURE__*/function (_VenueMapSectionInput) {
  _inherits(VenueMapRowInputEvent, _VenueMapSectionInput);
  function VenueMapRowInputEvent() {
    _classCallCheck(this, VenueMapRowInputEvent);
    return _callSuper(this, VenueMapRowInputEvent, arguments);
  }
  return _createClass(VenueMapRowInputEvent);
}(VenueMapSectionInputEvent);